<template>
  <van-popup
      :value="showPopup"
      position="bottom"
      @input="showPopup = $event"
      closeable
      style="border-top-left-radius: 16px;border-top-right-radius: 16px;"
  >
    <h3 class="title">{{ $t(`用户协议`) }}</h3>
    <div style="height: 70vh;overflow-y: hidden;box-sizing: border-box;">
      <iframe :src="article" frameborder="0" width="100%" height="100%" ></iframe>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant';
export default {
  components: {
    [Popup.name]: Popup
  },
  data() {
    return {
      showPopup: false
    };
  },
  computed: {
    article() {
      if (this.$store.state.language === 'zh-TW') {
        return './st-tw.html'
      }
      if (this.$store.state.language === 'en-US') {
        return './st-en.html'
      }
      return './st-zh.html'
    }
  }
}
</script>

<style scoped lang="less">
.title{
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  text-align: center;
  padding: 18px 0 12px;
}
</style>
